"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateChaselistFilters = exports.parseHccCodes = exports.formatVirtualCareCode = exports.formatHraCode = exports.calculatePriorYear = exports.getIncludedTiersDisplayValue = exports.Year = exports.ChaseListType = exports.defaultRAFTypes = void 0;
const advancedSearch_1 = require("../advancedSearch");
const constants_1 = require("../../../constants");
exports.defaultRAFTypes = [
    "C",
    "C1",
    "C2",
    "CP",
    "CF",
    "CN",
    "D",
    "G1",
    "G2",
    "I",
    "I1",
    "I2",
    "SE",
    "PA",
    "PC",
    "PD",
    "PF",
    "PG",
    "PI",
    "PJ",
    "PK",
];
var ChaseListType;
(function (ChaseListType) {
    ChaseListType["Retrospective"] = "retrochase";
    ChaseListType["Prospective"] = "proschase";
    ChaseListType["ProspectiveHRA"] = "proshrachase";
    ChaseListType["ProspectiveVirtualCare"] = "prosvirtualcarechase";
})(ChaseListType = exports.ChaseListType || (exports.ChaseListType = {}));
var Year;
(function (Year) {
    Year["Current"] = "current_year";
    Year["Prior"] = "prior_year";
    Year["BeforeLast"] = "prior2_year";
})(Year = exports.Year || (exports.Year = {}));
const getIncludedTiersDisplayValue = (includedTiers) => `any of ${(0, advancedSearch_1.firstOrAmountSelected)(includedTiers)}`;
exports.getIncludedTiersDisplayValue = getIncludedTiersDisplayValue;
const calculatePriorYear = (eligibilityYear, currentYear) => (priorString, prior2String) => 
// is the integer equality here different than the string equality?
parseInt(eligibilityYear, 10) === parseInt(currentYear, 10)
    ? priorString
    : prior2String;
exports.calculatePriorYear = calculatePriorYear;
const formatHraCode = (id) => `current HRA HCC list: ${id}`;
exports.formatHraCode = formatHraCode;
const formatVirtualCareCode = (_, index) => `virtual_care_hcc_tier_list_${index}`;
exports.formatVirtualCareCode = formatVirtualCareCode;
const parseHccCodes = (hccCodes, format) => Object.keys(hccCodes).reduce((ret, key, i) => {
    if (hccCodes[key].included) {
        ret.push(format(key, i));
    }
    return ret;
}, []);
exports.parseHccCodes = parseHccCodes;
// TODO: Why is this necessary? "translating" filters seems like a hack. We may want to refactor how this works
const translateChaselistFilters = (currentYear, { type, eligibilityYear, eligibilityDate, rafOpportunity, excludeNewEnrollee, excludeHospice, hraCodes, virtualCareCodes, }) => {
    const priorYearString = (currentYear - 1).toString();
    // (note from: Hernandez) TODO[TECHDEBT]: We could make this a little more robust and get the
    //                 category/pathnames from the config to avoid it getting
    //                 out of sync. Those names should rarely change though,
    //                 so not super urgent.
    const filtersArray = [];
    const calculatePriorValue = (0, exports.calculatePriorYear)(eligibilityYear, `${currentYear}`);
    if (type === ChaseListType.Retrospective) {
        filtersArray.push({
            value: rafOpportunity.toString(),
            operator: constants_1.AdvancedSearchOperators.GreaterThanOrEquals,
            category: calculatePriorValue("RAF_SCORE_PRIOR_YEAR", "RAF_SCORE_2_YEARS_PRIOR"),
            path: calculatePriorValue("priorRAFSuspectScore", "prior2RAFSuspectScore"),
            subjects: ["All Suspect Types"],
            active: true,
            label: "RAF Score from Suspect HCCs (All Suspect Types)",
            displayedValue: rafOpportunity.toString(),
        });
    }
    else {
        filtersArray.push({
            value: rafOpportunity.toString(),
            operator: constants_1.AdvancedSearchOperators.GreaterThanOrEquals,
            category: calculatePriorValue("RAF_SCORE_PRIOR_YEAR", "RAF_SCORE_CURRENT_YEAR"),
            path: calculatePriorValue("priorRAFSuspectScore", "currRAFSuspectScore"),
            subjects: ["All Suspect Types"],
            active: true,
            label: "RAF Score from Suspect HCCs (All Suspect Types)",
            displayedValue: rafOpportunity.toString(),
        });
    }
    const subjectYears = [];
    if (type === ChaseListType.Retrospective) {
        subjectYears.push(eligibilityYear === priorYearString ? Year.Prior : Year.Current);
        filtersArray.push({
            value: true,
            operator: constants_1.AdvancedSearchOperators.Equals,
            category: "ELIGIBILITY",
            path: "yrsEligible",
            subjects: subjectYears,
            active: true,
            label: `Year(s) Eligible (${eligibilityYear})`,
            displayedValue: eligibilityYear,
        });
    }
    else {
        subjectYears.push("current_year");
        filtersArray.push({
            value: eligibilityDate,
            operator: constants_1.AdvancedSearchOperators.GreaterThanOrEquals,
            category: "ELIGIBILITY",
            path: "eligDate",
            subjects: ["End Date"],
            active: true,
            label: "Eligibility Date (End Date)",
            displayedValue: eligibilityDate,
        });
        if (type === ChaseListType.ProspectiveHRA) {
            const includedTiers = (0, exports.parseHccCodes)(hraCodes, exports.formatHraCode);
            filtersArray.push({
                value: includedTiers,
                operator: constants_1.AdvancedSearchOperators.ContainsAny,
                category: "HCC_CODES",
                path: "hraHccCodes",
                subjects: subjectYears,
                active: true,
                label: "HRA Assessable HCC Codes (Current Year)",
                displayedValue: (0, exports.getIncludedTiersDisplayValue)(includedTiers),
            });
        }
        if (type === ChaseListType.ProspectiveVirtualCare) {
            const includedTiers = (0, exports.parseHccCodes)(virtualCareCodes, exports.formatVirtualCareCode);
            filtersArray.push({
                value: includedTiers,
                operator: constants_1.AdvancedSearchOperators.ContainsAny,
                category: "HCC_CODES",
                path: "virtualCareHccCodes",
                subjects: subjectYears,
                active: true,
                label: "Virtual Care Assessable HCC Codes (Current Year)",
                displayedValue: (0, exports.getIncludedTiersDisplayValue)(includedTiers),
            });
        }
    }
    if (excludeNewEnrollee) {
        filtersArray.push({
            value: exports.defaultRAFTypes,
            operator: constants_1.AdvancedSearchOperators.Included,
            category: "MONTHLY_MEMBERSHIP_REPORT",
            path: "mmrRafTypeCode",
            subjects: subjectYears,
            active: true,
            label: `RAF Type Code (${eligibilityYear})`,
            displayedValue: `${exports.defaultRAFTypes.length} selected`,
        });
    }
    if (excludeHospice) {
        filtersArray.push({
            value: false,
            operator: constants_1.AdvancedSearchOperators.Equals,
            category: "MONTHLY_MEMBERSHIP_REPORT",
            path: "mmrHospice",
            subjects: subjectYears,
            active: true,
            label: `Hospice (${eligibilityYear})`,
            displayedValue: "false",
        });
    }
    return filtersArray;
};
exports.translateChaselistFilters = translateChaselistFilters;
